import { Text as AriaText } from 'react-aria-components';

import { cx } from '@/lib/utils/cx';

import type { ReactNode, Ref } from 'react';
import type { TextProps as AriaTextProps } from 'react-aria-components';

interface HintTextProps extends AriaTextProps {
  /** Indicates that the hint text is an error message. */
  readonly isInvalid?: boolean;
  readonly ref?: Ref<HTMLElement>;
  readonly size?: 'sm' | 'md';
  readonly children: ReactNode;
}

export const HintText = ({ isInvalid, className, size = 'md', ...props }: HintTextProps) => {
  return (
    <AriaText
      {...props}
      className={cx(
        'text-sm text-tertiary',

        // Size
        size === 'sm' && 'text-xs',
        'in-data-[input-size=sm]:text-xs',

        // Invalid state
        isInvalid && 'text-error-primary',
        'group-invalid:text-error-primary',

        className,
      )}
      slot={isInvalid ? 'errorMessage' : 'description'}
    />
  );
};

HintText.displayName = 'HintText';
